

import React, { Component } from 'react';

class SupportUs extends Component {
  render() {
    return (
      <section>
        <header id="page-title">
          <div className="container">
            <h1>Support Us</h1>
          </div>
        </header>
        <section className="container">

          <p>
            If you are just visiting this website or our church, we want to say from the outset that we do not want to ask you for money.
            However, for regular attenders or full-blown partners with us at CRCK, it is one of our privileges and duties to give generously, sacrificially and cheerfully to the work of the gospel here.
            </p>

          <p>
            Far and away our preferred method of giving is by direct debit.  Please contact the church office to arrange this.  Alternatively you can deposit directly into the church bank account.<br /><br />
            Details are as follows:
              <ul>
              <li>Account name: Christian Reformed Church of Kingston Inc.</li>
              <li>BSB:  067 026</li>
              <li>Account:  2802 2340</li>
              <li>Reference: CRCK Giving </li>
            </ul>
          </p>


          <br />
          <p>We also take up a weekly special collection at our Sunday service.</p>

        </section>
      </section>
    );
  }
}

export default SupportUs;
